require('../../modules/es.typed-array.sort');
